import { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronUp } from 'lucide-react';
import Tooltip from './Tooltip';

export default function GoToTop({
  threshold = 220,
  className = '',
  scrollContainerRef = null,
  ariaLabel = 'Go to top',
}) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const container = scrollContainerRef?.current || null;
    const target = container || window;

    function getScrollTop() {
      if (container) return container.scrollTop;
      return window.scrollY || document.documentElement.scrollTop || 0;
    }

    function onScroll() {
      setVisible(getScrollTop() > threshold);
    }

    onScroll();
    target.addEventListener('scroll', onScroll, { passive: true });
    return () => target.removeEventListener('scroll', onScroll);
  }, [scrollContainerRef, threshold]);

  function handleClick() {
    const container = scrollContainerRef?.current || null;
    if (container) {
      container.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  return (
    <AnimatePresence>
      {visible ? (
        <Tooltip content={ariaLabel}>
          <motion.button
            type="button"
            onClick={handleClick}
            aria-label={ariaLabel}
            initial={{ opacity: 0, y: 16, scale: 0.94 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 16, scale: 0.94 }}
            transition={{ duration: 0.22, ease: [0.22, 1, 0.36, 1] }}
            whileHover={{ y: -2 }}
            whileTap={{ scale: 0.96 }}
            className={`fixed bottom-8 right-6 z-40 inline-flex h-11 w-11 items-center justify-center rounded-full border border-[var(--dash-border-strong)] bg-[var(--dash-surface)] text-[var(--dash-text)] shadow-lg hover:bg-[var(--dash-surface-2)] ${className}`}
          >
            <ChevronUp className="h-5 w-5" />
          </motion.button>
        </Tooltip>
      ) : null}
    </AnimatePresence>
  );
}
